var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-form-cmp',{directives:[{name:"animation",rawName:"v-animation:bottom.delay",arg:"bottom",modifiers:{"delay":true}}],staticClass:"_reviews",attrs:{"action":"reviews","form-config":_vm.form,"submit-label":_vm.button,"agreements":[_vm.PERSONAL_DATA_AGREEMENT]},scopedSlots:_vm._u([{key:"profilePublicationAgreement",fn:function(ref){
var field = ref.field;
var input = ref.input;
return [_c('FormField',{attrs:{"field":field}},[_c('ProfilePublicationAgreement',{attrs:{"value":field.value,"error":field.error},on:{"input":input}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/forms/form-reviews.vue?vue&type=template&id=eb9b6048&
// module id = 1246
// module chunks = 0